export const bezier1 = [0, -0.09, 0, 1.01];
export const bezier2 = [0, -0.09, 1, -1.01];
export const backgroundLineEase = 'easeOut';
